import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import {
  LayoutDashboard, Send, Users, ListChecks, Megaphone, Settings, LogOut, MessageCircle, FileInput, UsersRound, Zap
} from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const links = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard },
  { to: "/send", label: "Manual Send", icon: Send },
  { to: "/recipients", label: "Recipients", icon: Users },
  { to: "/lists", label: "Lists", icon: ListChecks },
  { to: "/campaigns", label: "Campaigns", icon: Megaphone },
  { to: "/forms", label: "Forms", icon: FileInput },
  { to: "/leads", label: "Leads", icon: UsersRound },
  { to: "/automations", label: "Automations", icon: Zap },
  { to: "/settings", label: "Settings", icon: Settings },
];

export default function Sidebar() {
  const { logout } = useAuth();

  return (
    <motion.aside
      initial={{ x: -20, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      className="w-64 h-screen bg-zinc-950 border-r border-zinc-800 flex flex-col fixed left-0 top-0 z-40"
    >
      <div className="px-6 py-5 border-b border-zinc-800">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-fuchsia-500 to-orange-500 flex items-center justify-center">
            <MessageCircle size={20} className="text-white" />
          </div>
          <div>
            <h1 className="text-sm font-bold text-white leading-tight">Adorance</h1>
            <p className="text-xs text-zinc-500">WA Platform</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
        {links.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            className={({ isActive }) =>
              "flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all " +
              (isActive
                ? "bg-fuchsia-500/10 text-fuchsia-400"
                : "text-zinc-400 hover:text-white hover:bg-zinc-800/60")
            }
          >
            <Icon size={18} />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="p-3 border-t border-zinc-800">
        <button
          onClick={logout}
          className="flex items-center gap-3 w-full px-3 py-2.5 rounded-xl text-sm font-medium text-zinc-400 hover:text-red-400 hover:bg-red-500/10 transition-all"
        >
          <LogOut size={18} />
          Sign Out
        </button>
      </div>
    </motion.aside>
  );
}
